<template>
  <p><small>{{ policiesString }}</small></p>
</template>

<script>
import { mapGetters } from "vuex";
import { POLICY_TYPE } from '../../../../../store/modules/marcom/data-model/policy-configurations';

export default {
  props: {
    objectWithPolicies: Object,
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      activeVenueDetails: "marcom/activeVenue",
      activeVenueSetups: "marcom/activeVenueSetups",
    }),
    policiesString() {
      if (this.getAllPolicies().length === 0) {
        return "No policies";
      } else {
        return this.getAllPolicies()
          .map((p) => {
            switch (p.policyType) {
              case POLICY_TYPE.OpeningHours: {
                return p.toLocalString(
                  this.activeVenueDetails.timeZoneInfo.olsonTimeZone
                );
              }
              default: {
                return p.toString();
              }
            }
          })
          .join(", ");
      }
    },
  },
  methods: {
    getAllPolicies() {
      let policiesAndSeatingStrategies = [];
      if(this.objectWithPolicies.venuePolicies)
        policiesAndSeatingStrategies = policiesAndSeatingStrategies.concat(this.objectWithPolicies.venuePolicies);
      if(this.objectWithPolicies.seatingStrategies)
        policiesAndSeatingStrategies = policiesAndSeatingStrategies.concat(this.objectWithPolicies.seatingStrategies);
      return policiesAndSeatingStrategies;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
